import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
import { NormalTable } from "component/common";
import print from "assets/images/reports/print.png";

export class PrintReportClass extends Component {
  state = {
    formFields: {
      projectTitle: "",
      projectDesc: "",
      status: "",
      custName: "",
      contactName: "",
      contactNumber: "",
    },
    SiteSelectionOption: [],
    SiteSelection: [],
    from_Date: new Date(),
    to_Date: new Date(),
    reports: [],
    ReportTable: [],
    projectList: [],

    statusOption: [],
    hide: true,
    is_loading: true,
    isPrintPdfClick: false,
    isMounted: true,
    treatmentListHeader: [
      // {
      //   label: "Issued by",
      //   className: " align-items-center justify-content-center",
      // },
      // {
      //   label: "Invoice Ref",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer Ref.",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Payment by others",
      //   className: " align-items-center justify-content-center",
      // },
      // {
      //   label: "TAXES",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Bank charges",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Receivables",
      //   className: "align-items-center justify-content-center",
      // },
    ],
    active: false,
    currentValue: 0,
    CollectionOutlet: [],
    perPage: 10,
    currentPage: 1,
    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      {
        to: this.props.location.pathname,
        label: "Quotation",
        id: "Quotation",
      },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
    PayModeOption: [],
    PayMode: [],
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  componentDidMount() {
    // this.handleViewReport();
    console.log(this.props.location?.state?.CollectionOutlet, "nivy");
    console.log(this.props?.location.state?.paymentTransactions, "nivy");
  }
  Print = () => {
    let printContents = document.getElementById("printablediv");
    this.setState({ showPrint: false });
    window.print();
  };

  render() {
    const payment = this.props?.location.state?.paymentTransactions;
    const headerDetails = this.props.location?.state?.CollectionOutlet;
    const date = this.props?.location.state?.payDate;
    let { ReportTable, CollectionOutlet } = this.state;
    const groupedData = {};
    payment.forEach((item) => {
      const { siteName, payTypes, amt, taxes, BankCharges, total } = item;
      if (!groupedData[siteName]) {
        groupedData[siteName] = {};
      }
      if (!groupedData[siteName][payTypes]) {
        groupedData[siteName][payTypes] = {
          items: [],
          totalAmt: 0,
          totalTaxes: 0,
          totalBankCharges: 0,
          total: 0,
        };
      }
      groupedData[siteName][payTypes].items.push(item);
      groupedData[siteName][payTypes].totalAmt += parseFloat(amt);
      groupedData[siteName][payTypes].totalTaxes += parseFloat(taxes);
      groupedData[siteName][payTypes].totalBankCharges +=
        parseFloat(BankCharges);
      groupedData[siteName][payTypes].total += parseFloat(total);
    });

    // Rendering the grouped data
    const siteNameKeys = Object.keys(groupedData);
    return (
      <div>
        <div className="row bg-white m-5">
          <div className="col-12">
            <div className="p-3 m-3" id="printablediv">
              <div className="row">
                <div className="col-md-6 ">
                  <h3 className="reports-heading my-5">
                    {headerDetails.title}
                    <span className="mx-2">|</span>
                    <span className="mx-2">{headerDetails.comp_title3} </span>
                    <span className="mx-2">|</span>
                    {headerDetails.comp_title4}
                    <span className="mx-2">|</span>
                  </h3>
                </div>
                <div className="col-md-6 mt-5 text-right">
                  {" "}
                  <button
                    className="pointer border bg-white col-4 p-2"
                    onClick={() => this.Print()}
                  >
                    <img src={print} alt="print" className="mx-3" />
                    Print
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 ">
                  <div className="row">
                    <div className="col-md-6 my-2">
                      <p className="report-label">Report Title</p>
                    </div>
                    <div className="col-md-6 my-2 ">
                      <p className="report-details">
                        {headerDetails.report_title}
                      </p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-label">From Date</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">
                        {headerDetails.from_date}
                      </p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-label">Printed by</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">{headerDetails.print_by}</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-label">Site</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">{headerDetails.site}</p>
                    </div>
                    {/* <div className="row col-12 mt-4">
                      <div className="col-md-6 fw-600 report-label">
                        Payment Type
                      </div>
                      <div className="col-md-6 fw-600 report-details">CASH</div>
                    </div> */}
                  </div>
                </div>
                <div className="col-md-6 ">
                  <div className="row">
                    <div className="col-md-6 my-2">
                      <p className="report-label">Outlet</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">{headerDetails.outlet}</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-label">To Date</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">{headerDetails.to_date}</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-label">print time</p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="report-details">
                        {headerDetails.print_time}
                      </p>
                    </div>
                    {/* 
                    <div className="col-md-6 mt-5 pt-1 fw-600 report-label">
                      Pay Date
                    </div>
                    <div className="col-md-6 mt-5 pt-1 fw-600 report-details">
                      {date}
                    </div> */}
                  </div>
                </div>
              </div>
              <div>
                {siteNameKeys.map((siteName) => (
                  <div key={siteName}>
                    <div className="row mt-5">
                      <div className="col-6">
                        {" "}
                        <h6 className="px-2 my-3">
                          Pay Date:{" "}
                          {
                            groupedData[siteName][
                              Object.keys(groupedData[siteName])[0]
                            ].items[0].payDate
                          }
                        </h6>
                      </div>
                      <div className="col-6">
                        {" "}
                        <h6 className="px-2 my-3">Outlet:{siteName}</h6>
                      </div>
                    </div>
                    {Object.keys(groupedData[siteName]).map((payType) => {
                      const {
                        items,
                        totalAmt,
                        totalTaxes,
                        totalBankCharges,
                        total,
                      } = groupedData[siteName][payType];
                      return (
                        <div key={payType}>
                          <h6 className="px-2  mt-4 mb-5">
                            Pay Type:{payType}
                          </h6>
                          <NormalTable
                            headerDetails={this.state.treatmentListHeader}
                          >
                            <thead>
                              <tr>
                                <th className="align-items-center justify-content-center">
                                  Issued by
                                </th>
                                <th className="align-items-center justify-content-center">
                                  Invoice Ref
                                </th>
                                <th className="align-items-center justify-content-center">
                                  Customer
                                </th>
                                <th className="align-items-center justify-content-center">
                                  Customer Ref.
                                </th>
                                <th className="text-center">
                                  Payment by others
                                </th>
                                <th className="text-center">TAXES</th>
                                <th className="text-center">Bank charges</th>
                                <th className="text-center">Receivables</th>
                              </tr>
                            </thead>
                            <div>
                              {items.map((item) => (
                                <>
                                  <tr>
                                    <td key={item.sa_transacno}>
                                      <div>{item.customer}</div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-left  text-lightblue fw-700">
                                        <button
                                          className="border-0 bg-white"
                                          onClick={() =>
                                            this.handleInvoiceRef(
                                              item.sa_transacno
                                            )
                                          }
                                        >
                                          {" "}
                                          {item.invoiceRef}
                                        </button>
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-left  ">
                                        {item.payRef}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-left  ">
                                        {item.CustRef}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center">
                                        {item.amt}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {item.taxes}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center  ">
                                        {item.BankCharges}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {item.total}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              ))}
                              <table className="table mb-0">
                                <thead></thead>
                                <tbody>
                                  <tr className="text-center">
                                    <td className="fw-700">TOTAL</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                    <td className="fw-700">Cash Total</td>
                                    {items.length > 0 && (
                                      <>
                                        {/* <td>{items[0].payDate}</td> */}
                                        <td className="fw-700 px-3 initial">
                                          {totalAmt}
                                        </td>
                                        <td className="fw-700 px-3 initial">
                                          {totalTaxes}
                                        </td>
                                        <td className="fw-700 px-3 initial">
                                          {totalBankCharges}
                                        </td>
                                        <td className="fw-700 px-3 initial">
                                          {total}
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </NormalTable>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  //   selectedid: state.consultation.SelectedId,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCommonApi, commonCreateApi }, dispatch);
};

export const PrintReport = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PrintReportClass)
);
